import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import App from './App.tsx';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <BrowserRouter>
    <Routes>
      {/* Series-specific routes */}
      <Route path="/series/:teamId/scheduled-topics" element={<App />} />
      <Route path="/series/:teamId/past-topics" element={<App />} />
      <Route path="/series/:teamId/deleted-topics" element={<App />} />
      <Route path="/series/:teamId/my-stats" element={<App />} />
      <Route path="/series/:teamId/series-info/edit" element={<App />} />
      
      {/* Series-agnostic routes */}
      <Route path="/my-stats" element={<App />} />
      <Route path="/about" element={<App />} />
      
      {/* Fallback routes - redirect to root to force proper URL usage */}
      <Route path="/scheduled-topics" element={<Navigate to="/" replace />} />
      <Route path="/past-topics" element={<Navigate to="/" replace />} />
      <Route path="/deleted-topics" element={<Navigate to="/" replace />} />
      <Route path="/" element={<App />} />
      
      {/* Catch-all redirect */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </BrowserRouter>
);
